const customerGetters = {
    customerFirstRender: state => routeName => {
        return state.customer.visited.indexOf(routeName) === -1;
    },
};

export default customerGetters;
